export const domainToProfileIdOptionsMap = {
    'c9a8aa49-9c91-4b84-5a06-b1772025a942': ['massachusetts', 'rhode-island', 'connecticut'],
    '27505a4f-f0fd-4cd2-5c40-5104d2166b32': ['nevada', 'louisiana', 'georgia']
}